/*
 * section_multi_image_cta — cycles the images inside the central Eros arc
 * frame. Mirrors Flutter's _RotatingArcFrame perf contract:
 *   - the interval only runs while the section is actually on screen,
 *   - it stops when the tab is hidden,
 *   - prefers-reduced-motion holds on the first image,
 *   - a single image (or interval <= 0) never starts a timer at all.
 * Crossfade is opacity-only (compositor), so a tick never triggers layout.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function setup(root) {
    var slides = root.querySelectorAll('[data-eros-mcta-slide]');
    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute('data-eros-mcta-interval'), 10);
    if (!(interval > 0)) return;

    var index = 0;
    var timer = null;
    var onScreen = false;

    function tick() {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }

    function start() {
      if (timer) return;
      if (!onScreen || document.hidden) return;
      if (reduced && reduced.matches) return;
      timer = setInterval(tick, interval);
    }

    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          onScreen = entries[entries.length - 1].isIntersecting;
          if (onScreen) start();
          else stop();
        },
        { threshold: 0 }
      ).observe(root);
    } else {
      onScreen = true;
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if (reduced && reduced.addEventListener) {
      reduced.addEventListener('change', function () {
        if (reduced.matches) stop();
        else start();
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-eros-mcta]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
